import { i18n } from '@/plugins/i18n'
import {
    bannerStatusStr,
    bannerStatusVariant
} from '@/constants/BannerStatus'
import DescriptionColumn from "./description-column.vue";
import router from '@/router'

const descriptionTemplate = (row, index, datatable) => {
    let template = new DescriptionColumn({
        props: {
            row,
            index,
            datatable,
        },
        i18n,
        router
    })

    template.row = row
    template.index = index
    template.datatable = datatable

    return template.$mount().$el
}



export default [
    {
        field: 'id',
        title: i18n.t('banner.id'),
        sortable: true,
        width: 70,
        type: 'number',
        textAlign: 'center',
    },
    {
        field: 'title',
        title: i18n.t('banner.title'),
        sortable: false,
        textAlign: 'center',
        template: (row) => {
            return '<a href="' + row.link + '">'+row.title+'</a>'
        },
        width: 80
    },
    {
        field: 'status',
        title: i18n.t('banner.status'),

        template: (row) => {
            let status  = bannerStatusStr.get(row.status)
            let variant = 'badge-'+bannerStatusVariant(row.status)

            return '<div class="badge '+variant+' text-white">'+ status+'</div>'
        },

        sortable: false,
        width: 80,
        textAlign: 'center',
    },
    {
        field: 'created_at',
        title: i18n.t('label.created_at'),
        sortable: false,
        width: 80,
        textAlign: 'center',
    },
    {
        field: 'description',
        width: 100,
        title: i18n.t('label.description'),
        template: (row, index, datatable) => {
            return descriptionTemplate(row, index, datatable)
        },
        sortable: false,
        textAlign: 'center',
    },
]